import { Deal } from '../types/deal';
import { colors } from '../styles/theme';

export const deals: Deal[] = [
  {
    iconName: "Crown",
    title: "ChatGPT Plus",
    description: "Accès premium à ChatGPT-4 et aux dernières fonctionnalités d'OpenAI",
    features: [
      "Accès prioritaire",
      "GPT-4 illimité",
      "Plugins avancés",
      "Mode développeur"
    ],
    originalPrice: "20€/mois",
    studentPrice: "Gratuit",
    color: colors.primary,
    link: "https://my.francestudent.org/store/bons-plans"
  },
  {
    iconName: "PlayCircle",
    title: "Disney+",
    description: "Streaming illimité de films, séries et documentaires",
    features: [
      "4K UHD & HDR",
      "4 écrans simultanés",
      "Téléchargements illimités",
      "Sans publicité"
    ],
    originalPrice: "5.99€/mois",
    studentPrice: "Gratuit",
    color: colors.secondary,
    link: "https://my.francestudent.org/store/bons-plans/disney-plus"
  },
  {
    iconName: "Music",
    title: "Spotify Premium",
    description: "Musique et podcasts sans limite et sans pub",
    features: [
      "Qualité audio supérieure",
      "Mode hors connexion",
      "Playlists illimitées",
      "Skip illimité"
    ],
    originalPrice: "6.06€/mois",
    studentPrice: "Gratuit",
    color: colors.tertiary,
    link:"https://my.francestudent.org/store/bons-plans/spotify-premium-3-mois"
  }
];